"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineHeights = void 0;
var lineHeights_1 = __importDefault(require("../tokens/lineHeights"));
exports.lineHeights = lineHeights_1.default;
//# sourceMappingURL=lineHeights.js.map